export const NATIVE_PUSH_DATA_KEYS = {
  SOURCE_TYPE: 'sourceType',
  SOURCE_ENTITY_ID: 'sourceEntityId',
};

export const NATIVE_PLATFORM = {
  IOS: 'ios',
  ANDROID: 'android',
};

export const PUSH_PLATFORM = {
  APNS: 'apns',
  FCM: 'fcm',
};
